import { render, staticRenderFns } from "./eol-banner.vue?vue&type=template&id=664c35e1&scoped=true"
import script from "./eol-banner.vue?vue&type=script&lang=js"
export * from "./eol-banner.vue?vue&type=script&lang=js"
import style0 from "./eol-banner.vue?vue&type=style&index=0&id=664c35e1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664c35e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1200771894/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664c35e1')) {
      api.createRecord('664c35e1', component.options)
    } else {
      api.reload('664c35e1', component.options)
    }
    module.hot.accept("./eol-banner.vue?vue&type=template&id=664c35e1&scoped=true", function () {
      api.rerender('664c35e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/eol-banner.vue"
export default component.exports